import axios from "@/http";

class Address {
  // 城市列表
  static getAddressMock() {
    const url = 'https://xinge-kz.oss-cn-hangzhou.aliyuncs.com/oa/template/address.json'
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default Address;